import Vue from "vue";
import VueI18n, { LocaleMessages, LocaleMessageObject } from "vue-i18n";
import es from "@/locales/es.json";

Vue.use(VueI18n);

function loadLocaleMessages(): LocaleMessages {
  return {
    en: {},  // Inglés por defecto (usamos las claves)
    es: es as LocaleMessageObject
  };
}

const i18n = new VueI18n({
  locale: "en", // idioma por defecto
  fallbackLocale: "en",
  messages: loadLocaleMessages()
});

export default i18n;
